import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

import { API } from '../constants/api.constant';
import { AppInfo } from '../models/app.model';
import { ResponseInfo } from '../models/http.model';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private readonly http = inject(HttpClient);

  appInfo = signal<AppInfo | null>(null);

  public getAppInfo(): Observable<AppInfo> {
    return this.http.get(API.PREFIX + API.APP_INFO).pipe(
      map((res: ResponseInfo) => {
        this.appInfo.set(res.result);
        return res.result;
      }),
      retry(3),
      catchError(() => {
        return EMPTY;
      })
    );
  }
  public contactUs(
    payload: {
      name?: string;
      phone?: string;
      email?: string;
      message?: string;
    } = {}
  ): Observable<any> {
    return this.http.post(API.PREFIX + API.CONTACT_US, payload);
  }
}
